export const textCenter = () => ({
  textCenter: true
});
//# sourceMappingURL=textCenter.js.map